import { FadeIn } from '@/components/motion/FadeIn';
import { MaskReveal } from '@/components/motion/Reveal';

interface Props {
  eyebrow?: string;
  headline: string;
  body: string;
  pull_quote?: string;
  pull_quote_attr?: string;
}

export function HomeMission({ eyebrow, headline, body, pull_quote, pull_quote_attr }: Props) {
  return (
    <MaskReveal className="section-y-lg" tilt={-1.5} duration={1.2} sheen>
      <div className="container-narrow">
        {eyebrow && (
          <FadeIn>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">{eyebrow}</p>
          </FadeIn>
        )}
        <FadeIn delay={0.05}>
          <h2 className="mt-3 text-h2 text-fg">{headline}</h2>
        </FadeIn>
        <FadeIn delay={0.1}>
          <p className="mt-6 text-lg text-fg-muted">{body}</p>
        </FadeIn>
        {pull_quote && (
          <FadeIn delay={0.2}>
            <blockquote className="mt-12 border-l-2 border-gold-500 pl-6 text-xl italic text-fg-muted">
              "{pull_quote}"
              {pull_quote_attr && (
                <footer className="mt-2 text-sm not-italic text-fg-subtle">— {pull_quote_attr}</footer>
              )}
            </blockquote>
          </FadeIn>
        )}
      </div>
    </MaskReveal>
  );
}
